import {
  FATTURE_IN_CLOUD_URL,
  TEAM_SYSTEM_DIGITAL_URL,
  TEAM_SYSTEM_STUDIO_HR_URL,
  PSP_YOUTUBE_CHANNEL_URL,
  PSP_WEBSITE_URL,
} from "@/config/constants";
import { translate } from "@/config/translator";
import { Persona, Text } from "@fluentui/react-components";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CookiesAndPrivacyLinks } from "../cookiesAndPrivacyLinks/cookiesAndPrivacyLinks";
import { useLeftBarMobile } from "./leftBarMobile/useLeftBarMobile";
import { Dispatch, SetStateAction } from "react";
import { LeftBarMobileLink } from "./leftBarMobile/leftBarMobileLink";
import Skeleton from "react-loading-skeleton";

type LeftBarMobileProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export function LeftBarMobile({ isOpen, setIsOpen }: LeftBarMobileProps) {
  const {
    closeLeftBarMobile,
    lang,
    onLogout,
    user,
    selectedMandate,
    currentRight,
  } = useLeftBarMobile({ setIsOpen });

  return (
    <>
      <button
        onClick={() => setIsOpen(false)}
        className={`
          fixed
          duration-0
          inset-0
          bg-black
          z-20
          transition-opacity
          ${isOpen ? "opacity-25" : "opacity-0 hidden"}
        `}
      />
      <div
        className={`
          duration-200
          fixed
          h-screen
          top-0
          ease-in-out
          w-[min(18rem,85vw)]
          bg-white
          z-20
          overflow-y-auto
          ${isOpen ? "left-0" : "-left-72"}
        `}
      >
        <div className="flex flex-col justify-start items-center pt-12 px-6 gap-8 h-full">
          <div className="w-full flex flex-row justify-start">
            {/* AVATAR WITH USER INFO */}
            <Persona
              name={user?.name}
              size="huge"
              secondaryText={user?.taxNumber?.toUpperCase() ?? "-"}
              tertiaryText={
                <Text className="text-font-secondary">
                  {selectedMandate?.name ?? <Skeleton />}
                </Text>
              }
            />
          </div>

          {/* NAVIGATION OPTIONS */}
          <div className="w-full pt-4 border-t border-t-neutral"></div>

          {/* MANDATES */}
          <LeftBarMobileLink onClick={closeLeftBarMobile} to="/switch-mandate">
            {translate("mandates", lang)}
          </LeftBarMobileLink>

          {/* CONTACT */}
          <LeftBarMobileLink onClick={closeLeftBarMobile} to="/contact-person">
            {translate("contact", lang)}
          </LeftBarMobileLink>

          {/* WEBSITE */}
          <LeftBarMobileLink isAElement to={PSP_WEBSITE_URL} newTab>
            {translate("website", lang)}
          </LeftBarMobileLink>

          {/* TEMPLATES AND INSTRUCTIONS */}
          {currentRight?.right.allowedTabs.includes("TEMPLATES") && (
            <LeftBarMobileLink
              onClick={closeLeftBarMobile}
              to="/templates-and-instructions"
            >
              {translate("templatesAndInstructions", lang)}
            </LeftBarMobileLink>
          )}

          {/* SMALL SPACING */}
          <div />

          {/* EXTERNAL LINKS */}
          {/* STUDIO HR */}
          <LeftBarMobileLink to={TEAM_SYSTEM_STUDIO_HR_URL} isAElement newTab>
            Studio HR
          </LeftBarMobileLink>

          {/* FATTURE IN CLOUD */}
          <LeftBarMobileLink to={FATTURE_IN_CLOUD_URL} isAElement newTab>
            Fatture In Cloud
          </LeftBarMobileLink>

          {/* TS DIGITAL */}
          <LeftBarMobileLink to={TEAM_SYSTEM_DIGITAL_URL} isAElement newTab>
            TS Digital
          </LeftBarMobileLink>

          {/* YOUTUBE */}
          <LeftBarMobileLink to={PSP_YOUTUBE_CHANNEL_URL} isAElement newTab>
            YouTube
          </LeftBarMobileLink>

          {/* BIG SPACING */}
          <div className="grow" />

          {/* SETTINGS */}
          <LeftBarMobileLink onClick={closeLeftBarMobile} to="/settings">
            {translate("settings", lang)}
          </LeftBarMobileLink>

          {/* SIGN OUT */}
          <button
            className="flex flex-row justify-between w-full items-center"
            onClick={onLogout}
          >
            <Text size={400}>{translate("signOut", lang)}</Text>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>

          {/* COOKIES AND PRIVACY */}
          <div className="pb-6">
            <CookiesAndPrivacyLinks />
          </div>
        </div>
      </div>
    </>
  );
}
